module.exports = {
    API_BASE: process.env.REACT_APP_API_BASE
}